import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./digitalmarketing.css"; // your CSS file

const digitalMarketingPlans = [
  {
    title: "Basic Plan",
    price: "₹4,999/-",
    subtitle: "Perfect for Startups",
    features: [
      "Social Media Setup (1 Platform)",
      "Basic SEO Optimization",
      "2 Promotional Posts Per Week",
      "Monthly Performance Report",
      "Email Campaign Setup (1 Campaign)"
    ]
  },
  {
    title: "Standard Plan",
    price: "₹9,999/-",
    subtitle: "Best for Small Businesses",
    popular: true,
    features: [
      "Social Media Setup (Up to 3 Platforms)",
      "Advanced SEO Optimization",
      "5 Promotional Posts Per Week",
      "Bi-Weekly Performance Report",
      "Email Campaigns (3 Campaigns)",
      "Google My Business Optimization",
      "Content Strategy & Planning"
    ]
  },
  {
    title: "Premium Plan",
    price: "₹15,999/-",
    subtitle: "For Growing Businesses",
    features: [
      "Social Media Setup (All Major Platforms)",
      "Premium SEO Optimization",
      "Daily Promotional Posts",
      "Weekly Performance Report",
      "Email Campaigns (5 Campaigns)",
      "Google Ads / Paid Campaign Management",
      "Content Strategy & Marketing Plan",
      "Basic Website Analytics & Reporting",
      "Competitor Analysis"
    ]
  },
  {
    title: "Custom Plan",
    price: "₹ ???",
    subtitle: "Tailored Digital Marketing Solution",
    features: [
      "All Platforms & Channels Managed",
      "Custom SEO & Marketing Strategy",
      "Daily Promotional Campaigns",
      "Advanced Analytics & Reporting",
      "Email Marketing Automation",
      "Google Ads, Facebook Ads & Paid Campaigns",
      "Influencer Marketing Strategy",
      "Dedicated Digital Marketing Manager",
      "Unlimited Revisions & Custom Requests"
    ]
  }
];

function DigitalMarketingPricing() {
  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-in-out",
    });
  }, []);

   const handleCall = () => {
    window.location.href = "tel:8778934301"; // opens phone dialer
  };

  return (
    <section className="pricing-section">
      <div className="container">
        <section className="section-margin">
          <div className="heading-for-all"  data-aos="fade-up">
            <h2>Digital Marketing</h2>
          </div>
        </section>

        <div className="pricing-grid">
          {digitalMarketingPlans.map((plan, index) => (
            <div
              key={index}
              className={`pricing-card ${plan.popular ? "popular" : ""}`}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              {plan.popular && <div className="popular-badge">POPULAR</div>}
              <h3 className="plan-title">{plan.title}</h3>
              <p className="plan-price">{plan.price}</p>
              <p className="plan-subtitle">{plan.subtitle}</p>
              <ul className="plan-features">
                {plan.features.map((feature, i) => (
                  <li key={i}>✅ {feature}</li>
                ))}
              </ul>
              <button className="choose-plan-btn" onClick={handleCall}>Choose Plan</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default DigitalMarketingPricing;
